;(function($){

  smoothstate__init();
  page__init();

function addBlacklistClass() {
    $( 'a' ).each( function() {
        if ( this.href.indexOf('/wp-admin/') !== -1 ||
             this.href.indexOf('/wp-login.php') !== -1 ) {
            $( this ).addClass( 'wp-link' );
        }
    });
} //addBlacklistClass();

function smoothstate__init() {

      var options = {
        prefetch: true,
        cacheLength: 2,
        anchors: 'a',
        blacklist: '.wp-link, input[type="submit"]',
        prefetch: false,
        onStart: {
          duration: 750, // Duration of our animation
          render: function ($container) {
              $container.addClass('is-exiting');
              Waypoint.destroyAll();
          }
        },
        onReady: {
          duration: 750,
          render: function ($container, $newContent) {
            // Inject the new content
            $container.html($newContent);
            lazyLoadInstance.update();

            setTimeout(function(){ setbodycolors($newContent);  }, 100); }
        },
        onAfter: function($container, $newContent) {

            $container.removeClass('is-exiting');
            addBlacklistClass();
            page__init();
            initHeaderFunctions();
            load_homepage_scroll_effect();
            lazyLoadInstance.update();
        }
      },

      smoothState = $('#wrapper').smoothState(options).data('smoothState');
} // smoothstate__init()

function setbodycolors($newContent){
    var $body = $('body');
    var $inner = $('.wrapper__inner', $newContent);
    $body.attr('data-pagecolor-bg', $newContent.attr('data-pagecolor-bg'));
    $body.attr('data-pagecolor-text', $newContent.attr('data-pagecolor-text'));
    $body.attr('data-page', $newContent.attr('data-page'));
} // setbodycolors()


function page__init() {

  // if($('#frontpagevideo').length > 0) {
  //   initVideo();
  // }
  //
  // function initVideo(){
  //
  //   $('#frontpagevideo').seeThru({start : 'autoplay'});
  //
  //   // if we end up using this it needs to be destroyed before moving on to another page
  // }

  gtm_hero_carousel__component();
  gtm_footer_carousel__component();

  /*  ==========================================================================
      links
      ========================================================================== */

  links__init();

  /*  ==========================================================================
      AJAX Load More
      ========================================================================== */

  var load_more_params = misha_loadmore_params;

  load_more_params.current_page = 1;

  $('.misha_loadmore').click(function(){

    var button = $(this),
        data = {
      'action': 'loadmore',
      'query': load_more_params.posts, // that's how we get params from wp_localize_script() function
      'page' : load_more_params.current_page};

    loadmore(button, data, load_more_params);
    lazyLoadInstance.update();
  });

  /*  ==========================================================================
      sharinglinks
      ========================================================================== */

  $('.sharelink--popup').click(function(e) {
    e.preventDefault();
    window.open($(this).attr('href'), 'share-dialog', 'width=550,height=436');
  });


  /*  ==========================================================================
      faqs
      ========================================================================== */

  $('.faq__question').click(function() {
    $(this).closest('.faq').toggleClass('faq--open');
  });

  /*  ==========================================================================
      flexcolor
      ========================================================================== */

  var $flexcolor = $('.flexcolor');

  if ($flexcolor.length > 0) {
    flexcolor__init();
  }
  function flexcolor__init() {

    $flexcolor.each(function( i, val ) {
      var $this = $(this);
      $this.waypoint({
        handler: function(direction) {

          if (direction === "down") {
            $this.attr('data-prevcolor-bg', $('body').attr('data-pagecolor-bg'));
            $this.attr('data-prevcolor-text', $('body').attr('data-pagecolor-text'));

            $('body').attr('data-pagecolor-bg', $this.data('pagecolor-bg'));
            $('body').attr('data-pagecolor-text', $this.data('pagecolor-text'));
          }

          if (direction === "up") {

            $('body').attr('data-pagecolor-bg', $this.data('prevcolor-bg'));
            $('body').attr('data-pagecolor-text', $this.data('prevcolor-text'));
          }

        },
        offset: '50%'
      });
    });
  }

  /*  ==========================================================================
      gradient parallax
      ========================================================================== */

      initGradients();
      function initGradients(){
        var ratio = .75,
            number = 4;

        $('.gradients').html(function(){
          var output = '';
          for (var i = 0; i <= number; i++) {
            output += '<div class="gradient gradient--'+i+'" data-enllax-ratio="'+ratio+'" data-enllax-type="foreground"></div>';
          }
          return output;
        });
        $('.gradients').addClass('gradients--ready');
        $('.gradients').enllax();
      }



  /*  ==========================================================================
      flexslides
      ========================================================================== */

  var $flexslides = $('.flexslides');

  if ($flexslides.length > 0) {
    flexslides__init();
  }

  function flexslides__init() {
    $flexslides.each(function() {
      var $this = $(this);
      var $this_slidecount = $('.flexslide', $this).length;
      if ($this_slidecount > 1) {
        $this.owlCarousel({
          loop: true,
          nav: false,
          dots: true,
          items: 1,
          startPosition: $this_slidecount,
          //autoplay: true,
          //autoplayTimeout: 5000,
          autoHeight: true
        }).waypoint({
          handler: function(direction) {
            if (direction === "down" && $this.data('alreadyscrolled') !== "true") {
              $this.trigger('next.owl.carousel').data('alreadyscrolled', 'true');
            }
          },
          offset: '50%'
        });
      }
    });

    $flexslides.on('resized.owl.carousel', function() {
      $flexslides.trigger('next.owl.carousel');
    });

  } // flexslides__init()


  /*  ==========================================================================
      pageheader gallery
      ========================================================================== */

  var $pageheader__gallery = $('.pageheader__gallery');

  if ($pageheader__gallery.length > 0) {
    gallery__init();
  }

  function gallery__init() {
    $pageheader__gallery.each(function() {
      var $this = $(this);
      var $this_slidecount = $('.pageheader__gallery__img', $this).length;
      if ($this_slidecount > 1) {
        $this.owlCarousel({
          loop: true,
          animateOut: 'fadeOut',
          nav: false,
          dots: false,
          items: 1,
          startPosition: $this_slidecount,
          autoHeight: false,
          autoplay: true,
          autoplayTimeout: 7000,
        });
      }
    });

    $pageheader__gallery.on('resized.owl.carousel', function() {
      $pageheader__gallery.trigger('next.owl.carousel');
    });

  } // gallery__init()


  /*  ==========================================================================
      mobnav
      ========================================================================== */

  var $mobnav = $('.mobnav');
  var $mobnavinner = $('.mobnav__bd', $mobnav);
  var $mobnavtoggle = $('.mobnav-toggle');
  var mobnavopenclass = 'mobnavopen';

  mobnav__init();

  function mobnav__init() {
    $mobnavtoggle.on("click touchend", function(e) {
      e.preventDefault();
      if ($mobnav.attr('data-status') !== "open") {
        // it's not open
        $mobnav.height($mobnavinner.outerHeight(false)).attr('data-status', 'open');
        $('body').addClass(mobnavopenclass);
      } else {
        // it's open
        $mobnav.height(0).attr('data-status', 'closed');
        $('body').removeClass(mobnavopenclass);
      }
    });

    $(window).resize(mobnav__resize);
  } // mobnav__init()

  function mobnav__resize() {
    if ($mobnav.attr('data-status') === "open") {
      $mobnav.height($mobnavinner.outerHeight(true)).attr('data-status', 'open');
    }
  } // mobnav__resize()


  /*  ==========================================================================
      effects
      ========================================================================== */

  var $effects = $('.effect');

  if ($effects.length > 0) {
    effects__init();
  }

  function effects__init() {
    $effects.each(function() {
      var $el = $(this);
      $el.waypoint({
        handler: function(direction) {
          if (direction === "down") {
            $el.addClass("effect--ready");
          }else{
            $el.removeClass("effect--ready");
          }
        },
        offset: '90%'
      });
    });
  } // effects__init()


  /*  ==========================================================================
      pageheader background
      ========================================================================== */

  // Fadein page header image
  // $('.pageheader__img').bgLoaded({
  //   afterLoaded: function() {
  //     $('body').addClass('pageheaderimg--loaded');
  //   }
  // });

  /*  ==========================================================================
      pageheader video background
      ========================================================================== */

  // Fade in page header video
  if ($("#pageheadervideo__iframe").length) {
    // page header video is not playing yet, so continue to check before running transition
    var iframe = document.getElementById('pageheadervideo__iframe');
    var player = new Vimeo.Player(iframe);
    player.ready().then(function() {
      // the player is ready
      $('body').addClass('has-videoheader--playing');
    });
  }


  /*  ==========================================================================
      Companies -- Category Filter
      ========================================================================== */

  if ($('.filter__list').length) {

    $('.filter__category').click(function(e) {

      var termid = $(this).data('termid')

      // add/remove active class in filter
      $('.filter__category').removeClass("active");
      $(this).addClass("active");

      // remove all filtering
      if(termid == 'all'){
        $('.companies').removeClass('companies--filtering');
        $('.craneportfolio').removeClass('craneportfolio--filtering');
        $('.company').fadeIn();
        return true;
      }

      //adding class to mark filtering
      $('.craneportfolio').addClass('craneportfolio--filtering');
      $('.companies').addClass('companies--filtering');
      $('.company').hide();

      // company filter loop
      $('.company').each(function() {
        var $this = $(this);

        var categories_array = $this.data('categories');

        if($.inArray(termid, categories_array) != -1){
          $this.fadeIn();
        }

      });

    });
  }



  /*  ==========================================================================
      popupsearch
      ========================================================================== */

  var $searchtoggle = $('.searchpopup-toggle');
  var searchtoggleopenclass = "popupsearch--open";
  var $searchform = $('.searchpopupform');
  var $searchinput = $('input[name="s"]', $searchform);
  search__init();

  function search__init() {
    $searchtoggle.on("click touchend", function(e) {
      e.preventDefault();
      if (!$('body').hasClass(searchtoggleopenclass)) {
        // it's not open
        $('body').addClass(searchtoggleopenclass);
        if (!Modernizr.touch) {
          $searchinput.focus();
        }
      } else {
        // it's open
        $('body').removeClass(searchtoggleopenclass);
      }
    });

    $('.searchsubmit').click(function(e) {
      e.preventDefault();
      $searchform.submit();
    });

    $(document).keyup(function(e) {
      if ($('body').hasClass(searchtoggleopenclass)) {
        if (e.keyCode === 27) {
          $searchtoggle.first().click();
        }

        if (e.keyCode === 13) {
          $searchform.submit();
        }
      }
    });
  } // search__init()

  // Hide if you click in the background of the search popup
  $('.searchpopup').on('click', function(e) {
    if (e.target !== this)
      return;
    // it's open
    $('body').removeClass(searchtoggleopenclass);
  });

}

})(jQuery); // Domready


/*  ==========================================================================
    pageheadervideo fade
    ========================================================================== */

    load_homepage_scroll_effect();

    function load_homepage_scroll_effect(){
      if ($(".pageheader__bg--frontpage").length){
        var controller = new ScrollMagic.Controller();

        var tween = TweenMax.to(".pageheader__bg--frontpage", 1, {opacity: 0});

        var scene = new ScrollMagic.Scene({ triggerElement: ".videobgtrigger", duration: 500, offset: 0})
          .setTween(tween) // trigger a TweenMax.to tween
          .addTo(controller);
      }
    }

/*  ==========================================================================
    GLOBAL FUNCTIONS: links
    ========================================================================== */

function links__init($context) {
  var $links = $('a').not('.noline, .noline a, .line--added, .filter__list a');

  $links.each(function() {
    var $this = $(this);
    var $icon = $('.fa, .fas, .far, .fal, .fab', $this);

    if ($('img', $this).length < 1) {
      $this.wrapInner("<span class='linkline'>");
      $this.addClass('line--added');
      if ($icon.length > 0) {
        if ($icon.hasClass('fa--left')) {
          $icon.insertBefore($('.linkline', $this));
        } else {
          $icon.insertAfter($('.linkline', $this));
        }
      }
    }
  });
} // links__init()

/*  ==========================================================================
    GLOBAL FUNCTIONS: loadmore
    ========================================================================== */

function loadmore(button, data, load_more_params){
  $.ajax({ // you can also use $.post here
    url : load_more_params.ajaxurl, // AJAX handler
    data : data,
    type : 'POST',
    beforeSend : function ( xhr ) {
      button.text('Loading...'); // change the button text, you can also add a preloader image
    },
    success : function( data ){
      if( data ) {
        button.text( 'Load more' )
        $('.posts').append(data); // insert new posts
        load_more_params.current_page++;

        if ( load_more_params.current_page == load_more_params.max_page ) {
          button.remove(); // if last page, remove the button
        }

        lazyLoadInstance.update();

        // you can also fire the "post-load" event here if you use a plugin that requires it
        // $( document.body ).trigger( 'post-load' );

      } else {

        button.remove(); // if no data, remove the button as well

      }
    }
  });
}

  /*  ==========================================================================
      GTM Footer Carousel(s)
      ========================================================================== */
      function gtm_footer_carousel__component(){
        var $gtm_footer_carousel = $('.gtm-footer-carousel');

        if ($gtm_footer_carousel.length > 0) {
          gtm_footer_carousel__init();
        }

        function gtm_footer_carousel__init() {

          function resize_handler(e){
            var items     = e.item.count;
            var items_visible = e.page.size;
            //console.log('items',items);
            //console.log('visible',items_visible);
            if (items_visible < items){
              $(e.target).find('.gtm-f-carrousel__nav').css('display','block');
            } else{
              $(e.target).find('.gtm-f-carrousel__nav').css('display','none');
            }
          }
          function change_handler(e){
              console.log(e);
          }

          $gtm_footer_carousel.each(function() {
            var $this = $(this),
                $this_postcount = $('.tile', $this).length,
                $items = { 0:{ items:1, stagePadding:0 }, 700:{ items:1 , stagePadding:0 }, 1000:{ items:3, stagePadding:0 }};


            if ($this_postcount > 1) {
              $this.owlCarousel({
                loop: false,
                nav: false,
                dots: false,
                responsive: $items,
                autoplay: false,
                autoHeight: true,
                onResize: resize_handler,
                onChanged: change_handler
              });

              $this.closest('.carousel').find('.carousel__nav--next').click(function() {
                  $this.trigger('next.owl.carousel');
              });
              // Go to the previous item
              $this.closest('.carousel').find('.carousel__nav--prev').click(function() {
                  $this.trigger('prev.owl.carousel', [300]);
              });
              $this.trigger('resize.owl.carousel');
            }

          });


        } // flexslides__init()
      }



/*  ==========================================================================
    GTM Homepage Hero Carousel(s)
    ========================================================================== */
      function gtm_hero_carousel__component(){
        var $gtm_hero_carousel = $('.gtm-hero-carousel');

        //console.log('amount', $gtm_hero_carousel.length);
        if ($gtm_hero_carousel.length > 0) {
          gtm_hero_carousel__init();
        }

        function gtm_hero_carousel__init() {

          function resize_handler(e){
            var items     = e.item.count;
            var items_visible = e.page.size;
            //console.log('items',items);
            //console.log('visible',items_visible);
            if (items_visible < items){
              $(e.target).find('.gtm-hero-carrousel__nav').css('display','block');
            } else{
              $(e.target).find('.gtm-hero-carrousel__nav').css('display','none');
            }
          }

          function change_handler(e){
            //console.log(e);
            $this = $(e.target);
            $this.closest('.carousel').find('.carousel__counter-index').text(e.item.index + 1);
            $this.closest('.carousel').find('.carousel__counter-total').text(e.item.count);
            $this.closest('.carousel').find('.gtm-hero__photos').each(function(){
              $photos = $(this);
              $photos.find('.prev').removeClass('prev');
              $photos.find('.active').addClass('prev').removeClass('active');
              $photos.find('.gtm-hero__photo').eq(e.item.index).addClass('active');
            });

            $this.closest('.carousel').find('.gtm-hero-carousel__bgs').each(function(){
              $photos = $(this);
              $photos.find('.prev').removeClass('prev');
              $photos.find('.active').addClass('prev').removeClass('active');
              $photos.find('.bgslide').eq(e.item.index).addClass('active');
            });

            if(e.item.index == (e.item.count -1)){
                $('.gtm-hero-carousel__nav .carousel__nav--next').addClass('disabled');
            }else{
                $('.gtm-hero-carousel__nav .carousel__nav--next').removeClass('disabled');
            }

            if(e.item.index == 0){
                $('.gtm-hero-carousel__nav .carousel__nav--prev').addClass('disabled');
            }else{
                $('.gtm-hero-carousel__nav .carousel__nav--prev').removeClass('disabled');
            }
          }
          $gtm_hero_carousel.each(function() {
            var $this = $(this),
                $this_postcount = $('.carousel__item', $this).length;


            if ($this_postcount > 1) {
              $this.owlCarousel({
                loop: false,
                nav: false,
                dots: false,
                items : 1,
                itemsDesktop : false,
                itemsDesktopSmall : false,
                itemsTablet: false,
                itemsMobile : false,
                autoplay: false,
                autoHeight: false,
                animateIn: 'fadeIn',
                animateOut: 'fadeOut',
                onResize: resize_handler,
                onChanged: change_handler,
              });

              $this.closest('.carousel').find('.carousel__nav--next').click(function() {
                 //console.log('-----// here //-----');
                  $this.trigger('next.owl.carousel');
              });
              // Go to the previous item
              $this.closest('.carousel').find('.carousel__nav--prev').click(function() {
                  $this.trigger('prev.owl.carousel', [300]);
              });
              $this.trigger('resize.owl.carousel');
            }

          });
        }
      }


/*  ==========================================================================
  LAZYLOAD - Enable Lazy load for images
  ========================================================================== */

  // Lazy load images (or everything with .lazy)
  var lazyLoadInstance = new LazyLoad({});


  ;(function($){

    /*  ==========================================================================
        Line chart js
        ========================================================================== */
  
      var $linecharts = $('.chart--line');
  
      if($linecharts.length > 0){
        charts__line_init();
      }
  
      function charts__line_init(){
        $linecharts.each(function(){
          var $chart = $(this);
          var $chartdata = $('.chart__data', $chart);
          var $chartcanvas = $('.chart__canvas', $chart);
          var $chartcanvas_el = $chartcanvas.get(0);
          var $chartlabels = $chart.data('labels-x');
          var $chartlabels_array = $chartlabels.split(",");
  
          var datasets_array = Array();
  
          $('.dataline' ,$chartdata).each(function(){
            var $dataset = $(this);
            var $dataset_color = $dataset.data('color');
            var $dataset_label = $dataset.data('label');
            var $dataset_data = $dataset.data('data');
            var $dataset_data_array = $dataset_data.split(",");
  
  
            datasets_array.push({
              label: $dataset_label,
              fill: false,
              lineTension: 0,
              borderWidth: 1,
              borderColor: $dataset_color,
              borderCapStyle: 'butt',
              borderDash: [],
              borderDashOffset: 0.0,
              borderJoinStyle: 'miter',
              pointBorderColor: $dataset_color,
              pointBackgroundColor: "#fff",
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBackgroundColor: $dataset_color,
              pointHoverBorderColor: "rgba(220,220,220,1)",
              pointHoverBorderWidth: 2,
              pointRadius: 2,
              pointHitRadius: 10,
              data: $dataset_data_array,
              spanGaps: false
            });
          });
  
  
          new Chart($chartcanvas_el, {
            type: 'line',
            data: {
              labels: $chartlabels_array,
              datasets: datasets_array
            },
            options: {
              legend: {
                display: false
              },
              tooltips:{
                backgroundColor: "#eeeeee",
                bodyFontColor: "#111111",
                titleFontColor: "#111111",
                titleMarginBottom: 10,
                xPadding: 10,
                yPadding: 10
              }
            }
          });
  
        });
      } // charts__line_init ()
  
  
    /*  ==========================================================================
        pie chart js
        ========================================================================== */
  
      var $piecharts = $('.chart--pie');
  
      if($piecharts.length > 0){
        charts__pie_init();
      }
  
      function charts__pie_init(){
        $piecharts.each(function(){
          var $chart = $(this);
          var $chartdata = $('.chart__data', $chart);
          var $chartcanvas = $('.chart__canvas', $chart);
          var $chartcanvas_el = $chartcanvas.get(0);
  
          var data_labels = Array();
          var data_colors = Array();
          var data_values = Array();
  
          $('.datavalue', $chartdata).each(function(){
            //data_labels.push($(this).data('label'));
            data_labels.push(' ');
            data_colors.push($(this).data('color'));
            data_values.push($(this).data('val'));
          });
  
          new Chart($chartcanvas_el, {
             type: 'pie',
             data: {
                   labels: data_labels,
                   datasets: [{
                       data: data_values,
                       backgroundColor: data_colors,
                      borderWidth: 1
                   }]
               },
               options: {
                 legend: {
                       display: false,
                   },
              tooltips: {
                mode: 'index',
                /*backgroundColor: "#eeeeee",
                bodyFontColor: "#111111",
                titleFontColor: "#111111",
                titleMarginBottom: 10, */
                titleFontSize: 0,
                xPadding: 10,
                yPadding: 10
              }
               }
          });
  
        });
      } // charts__pie_init ()
  
      /*  ==========================================================================
          bar chart js
          ========================================================================== */
  
        var $barcharts = $('.chart--bar');
  
        if($barcharts.length > 0){
          charts__bar_init();
        }
  
        function charts__bar_init(){
          $barcharts.each(function(){
            var $chart = $(this);
            var $chartdata = $('.chart__data', $chart);
            var $chartcanvas = $('.chart__canvas', $chart);
            var $chartcanvas_el = $chartcanvas.get(0);
  
            var data_labels = Array();
            var data_colors = Array();
            var data_values = Array();
  
            $('.datavalue', $chartdata).each(function(){
              data_labels.push($(this).data('label'));
              data_colors.push($(this).data('color'));
              data_values.push($(this).data('val'));
            });
  
            new Chart($chartcanvas_el, {
               type: 'bar',
               data: {
                     labels: data_labels,
                     datasets: [{
                         data: data_values,
                         backgroundColor: data_colors
                     }]
                 },
  
                 options: {
                scales: {
                      xAxes: [{
                    display: false,
                          maxBarThickness: 50,
                    barPercentage: .5
                      }],
                                yAxes: [{
                                    ticks: {
                                        beginAtZero: true
                                    }
                                }]
                  },
                   legend: {
                         display: false,
                     },
                tooltips:{
                  mode: 'index',
                  /*backgroundColor: "#eeeeee",
                  bodyFontColor: "#111111",
                  titleFontColor: "#111111",
                  titleMarginBottom: 10, */
                  titleFontSize: 0,
                  xPadding: 10,
                  yPadding: 10
                },
  
  
                 }
            });
  
          });
        } // charts__line_init ()
  
  
  
    /*  ==========================================================================
      Stacked bar chart js
      ========================================================================== */
  
      var $stackedcharts = $('.chart--barstacked');
  
      if($stackedcharts.length > 0){
        charts__stacked_init();
      }
  
      function charts__stacked_init(){
        $stackedcharts.each(function(){
          var $chart = $(this);
          var $chartdata = $('.chart__data', $chart);
          var $chartcanvas = $('.chart__canvas', $chart);
  
          $chartcanvas.html("<div class='stackedcanvas'></div>");
          var $stackedcanvas = $('.stackedcanvas', $chartcanvas);
  
          var data_values_array = Array();
  
          $('.datavalue', $chartdata).each(function(){
            data_values_array.push($(this).data('val'));
          });
  
          var data_values_total = data_values_array.reduce(charts__stacked_reduce, 0);
  
          $('.datavalue', $chartdata).each(function(i){
            var $el = $(this);
            var el_val = $el.data('val');
            var el_percent = (el_val / data_values_total) * 100;
            $stackedcanvas.append("<div class='stackeditem fontsize--tiny' style='height:"+el_percent+"%'><div class='stackeditem__bg' style='background-color:"+$el.data("color")+";'></div><div class='stackeditem__info'><h4 class='stackeditem__value fontsize--tiny'>"+$el.data("val")+"</h4><div class='stackeditem__title'>"+$el.data("label")+"</div></div></div>");
          });
  
        });
      } // charts__line_init ()
  
  
    /*  ==========================================================================
      Stacked bar chart js
      ========================================================================== */
  
      var $horizstackedcharts = $('.chart--horizstacked');
  
      if($horizstackedcharts.length > 0){
        charts__horizstacked_init();
      }
  
      function charts__horizstacked_init(){
        $horizstackedcharts.each(function(){
          var $chart = $(this);
          var $chartdata = $('.chart__data', $chart);
          var $chartcanvas = $('.chart__canvas', $chart);
  
          $chartcanvas.html("<div class='stackedcanvas'></div>");
          var $stackedcanvas = $('.stackedcanvas', $chartcanvas);
  
          var data_values_array = Array();
  
          $('.datavalue', $chartdata).each(function(){
            data_values_array.push($(this).data('val'));
          });
  
          var data_values_total = data_values_array.reduce(charts__stacked_reduce, 0);
  
          $('.datavalue', $chartdata).each(function(i){
            var $el = $(this);
            var el_val = $el.data('val');
            var el_percent = (el_val / data_values_total) * 100;
            var el_class = (el_percent < 5) ? "stackeditem--lt5" : "";
            $stackedcanvas.append("<div class='stackeditem fontsize--tiny "+el_class+"' style='width:"+el_percent+"%'><div class='stackeditem__bg' style='background-color:"+$el.data("color")+";'></div><div class='stackeditem__info'><h4 class='stackeditem__value fontsize--tiny'>"+parseInt(el_percent)+"%</h4></div></div>");
          });
  
        });
      } // charts__line_init ()
  
  
      function charts__stacked_reduce(a,b){
        return a + b;
      } //charts__stacked_reduce
  
  
  })(jQuery); // Domready



/*  ==========================================================================
  HEADER bg color and dropshadow on scroll, margin top for notibar
  ========================================================================== */

  function initHeaderFunctions() {
    const header = document.querySelector(".siteheader");
    const body = document.body;
    let hasScrolled = false;

    // Map page color names to their corresponding hex values
    const colorMap = {
        white: "#ffffff",
        slate: "#262626",
        cream: "#fcf5eb",
        navy: "#044863",
        coral: "#ff696a",
        green: "#b1cfc1",
        lilac: "#d9c0e5",
        lavender: "#9f82ff",
        purple: "#b655bf",
        pink: "#ff81a7"
    };

    function updateHeaderStyle() {
        const pageColor = body.getAttribute("data-pagecolor-bg"); // Get the color name
        const hexColor = colorMap[pageColor] || "#ffffff"; // Default to white if undefined

        if (window.scrollY > 0) {
            header.style.backgroundColor = hexColor;
            header.style.boxShadow = "rgba(0, 0, 0, 0.05) 0px 35px 35px"; // Add shadow
            hasScrolled = true;
        } else if (hasScrolled) {
            header.style.backgroundColor = "transparent";
            header.style.boxShadow = "none"; // Remove shadow
            hasScrolled = false;
        }
    }

    function updateHeaderMargin() {
        const notificationBar = document.querySelector(".easy-notification-bar");

        if (notificationBar) {
            const notificationHeight = notificationBar.offsetHeight;
            header.style.marginTop = `${notificationHeight}px`; // Apply margin
        } else {
            header.style.marginTop = "0"; // Reset margin if no notification bar
        }
    }

    // Attach event listeners
    window.addEventListener("scroll", updateHeaderStyle);
    window.addEventListener("resize", updateHeaderMargin);

    // Run immediately
    updateHeaderStyle();
    updateHeaderMargin();
}

// Run on initial page load
document.addEventListener("DOMContentLoaded", initHeaderFunctions);

// Hook into SmoothState.js to re-run script after page transitions
$(document).on("smoothState:after", function () {
    initHeaderFunctions();
});